import React from 'react'
import { useFieldConfigSchemes } from '../../../Hooks/Features/TaskLayout/Fields/useFieldConfigSchemes'
import CommonGrid from '../../CommonCompo/CommonGrid/CommonGrid';
import { Dialog } from 'primereact/dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from "underscore";
import CommanDialog from '../../CommonCompo/CommanDialog/CommanDialog';
import FieldSchemeIssueType from './FieldSchemeIssueType';
import { renderField } from '../../../utils/Helper';

const FieldConfigSchemes = ({ filterValues, setFilterValues }) => {

    const { columns, rowData, loader, formValues, setFormValues, upsertFieldConfigScheme, formFields, handleChange } = useFieldConfigSchemes({ filterValues, setFilterValues });

    return (
        <div>
            {!_.isEmpty(filterValues?.scheme) ?
                <FieldSchemeIssueType filterValues={filterValues} setFilterValues={setFilterValues} /> :
                <div>
                    <div className='d-flex justify-content-between gap-1 mb-2'>
                        <input className='sk-input-dd w85 mb-0' placeholder='Search Schemes...' value={formValues?.search} onChange={(e) =>setFormValues((prev) => ({ ...prev, search: e?.target?.value }))} />
                        <div className='d-flex gap-2'>
                            <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => setFormValues((prev) => ({ ...prev, visible: true }))}><FontAwesomeIcon icon="fa-solid fa-plus" /> Scheme</button>
                        </div>
                    </div>
                    <div style={{ height: "calc(100vh - 150px)", overflow: "auto" }}>
                        <CommonGrid columns={columns} data={[{ id: "all", title: "", children: rowData }]} headerHeight={40} rowHeight={"auto"} loader={loader?.grid} strippedTable={true} />
                    </div>
                </div>
            }

            <Dialog className='modal-medium' visible={formValues?.visible} onHide={() => setFormValues({})} header={`${formValues?.isCopy ? "Copy" : !_.isEmpty(formValues?.editData) ? "Edit" : "Create"} Field Configuration Scheme`} draggable={false}>
                <div>
                    <div className='row'>
                        {formFields?.map((item, index) => (
                            renderField(item, index, (e, is_edit) => { handleChange(item, e) }, formValues, {}, {}, () => { }, () => { })
                        ))}
                    </div>
                    <div className='d-flex gap-1 justify-content-end mt-2'>
                        <button className='sk-btn sk-btn-primary' onClick={() => setFormValues({})}>Cancel</button>
                        {loader?.btn ? <button className="sk-btn sk-btn-primary bg-black text-white" style={{ width: "65px" }}>
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button>
                            : <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => upsertFieldConfigScheme()}>Submit</button>
                        }
                    </div>
                </div>
            </Dialog>

            <CommanDialog visible={formValues?.isDelete} handleClose={() => setFormValues({})} handleFun={() => upsertFieldConfigScheme()} message="Are you sure you want to delete this field configuration scheme?" />
        </div>
    )
}

export default FieldConfigSchemes